import { HedgeHogLogo } from './HedgeHogLogo'

interface NavBrandLinkProps {
  href?: string
}

export const NavBrandLink = ({ href = '/' }: NavBrandLinkProps) => {
  return (
    <a
      href={href}
      className="flex min-h-11 items-center gap-2 rounded-sm text-neutral-900 transition-colors duration-200 hover:text-neutral-700 focus-visible:outline-none focus-visible:ring-2 focus-visible:ring-orange-hover focus-visible:ring-offset-2"
      aria-label="Go to Benepicks home"
    >
      <HedgeHogLogo
        size="w-8 h-8 sm:w-9 sm:h-9"
        fill="currentColor"
        aria-hidden="true"
      />
      <span className="font-sans font-bold text-xl sm:text-[22px] tracking-tight">
        Benepicks
      </span>
    </a>
  )
}
